export default __webpack_public_path__ + "static/CookieRun-Regular.subset-30e0d2080e81bf39dd947e999ffdb207.otf";